import { FaRegTimesCircle } from "react-icons/fa";
import { GoCheckCircle } from "react-icons/go";

const Notifications = ({ t }) => {
  const notifications = [
    {
      id: 1,
      title: "طلب عضوية VIP جديد",
      desc: "لديك طلب عضوية VIP معلق من أحمد هشام المدير",
      time: "منذ 25 دقيقة",
      actions: true,
    },
    {
      id: 2,
      title: "منتج قاراب على النفاذ",
      desc: 'منتج "مضارب التنس" وصل للحد الأدنى من المخزون',
      time: "منذ ساعة واحدة",
      actions: false,
    },
  ];

  return (
    <section className="border border-[#374151] rounded-2xl p-6 shadow-md mainLinear w-full">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-semibold">{t("notifications")}</h2>
        <span className="text-xs text-yellow-500 cursor-pointer">{t("viewAll")}</span>
      </div>

      <div className="space-y-2">
        {notifications.map((note) => (
          <div
            key={note.id}
            className="bg-sideBar border border-[#374151] rounded-lg p-3 flex flex-col"
          >
            <h3 className="text-sm font-semibold">{note.title}</h3>
            <div className="flex items-center justify-between">
              <p className="text-xs text-sm text-mainGray">{note.desc}</p>
              {note.actions && (
                <div className="flex items-center space-x-2 rtl:space-x-reverse">
                  <GoCheckCircle
                    size={24}
                    className="text-lg text-[#3D9635] cursor-pointer"
                  />
                  <FaRegTimesCircle
                    size={24}
                    className="text-lg text-[#F0516D] cursor-pointer"
                  />
                </div>
              )}
            </div>

            <span className="text-[10px] text-mainGray">{note.time}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Notifications;
